import { useEffect, useState } from 'react';

type Theme = 'light' | 'dark';

// The initial class is set by the inline script in public/index.html to avoid a flash.
export default function useTheme() {
  const [theme, setTheme] = useState<Theme>(() =>
    document.documentElement.classList.contains('dark') ? 'dark' : 'light'
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem('theme', next); } catch {}
    setTheme(next);
  };

  return { theme, toggle };
}
